(function() {
	'use strict';

	angular.module('app.supplyChain')
		.service('crossSiteService', crossSiteService);

	function crossSiteService($http, URLS) {
		var getFactoriesPromise;
		return {
			getFactories: getFactories
		};

		function getFactories() {
			getFactoriesPromise = getFactoriesPromise || $http.get(URLS.host + String.format(URLS.sitesByCustomerNoPilot, globalConfig.factory.id, globalConfig.customer.id) + '&includeInaccessibleSites=true')
				.then(getFactoriesComplete)
				.catch(getFactoriesFailed);
			return getFactoriesPromise;

			function getFactoriesComplete(response) {
				return response;
			}

			function getFactoriesFailed(error) {
				return error;
			}
		}
	}
})();
